import React, { ChangeEvent, forwardRef, memo, ReactNode } from 'react';
import { IRequiredIdentify } from '@src/models/analytics';
import { IIconValueProps, IWithStylesProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import styled from './Switch.scss';
import { SwitchLabelValue } from './_LabelValue/SwitchLabelValue';
import { onUnitClickCallback } from '@src/core/Unit';

export interface ISwitchProps extends IWithStylesProps, IRequiredIdentify, IIconValueProps {
  disabled?: boolean;

  /** Выбранное значение */
  value?: boolean;

  /** Колбек, возвращающий выбранное значение */
  onChange?: (v: boolean) => void;

  /** Положение лейбла */
  labelPlacement?: 'start' | 'end';

  /** Контейнер на всю ширину контент по краям */
  isWide?: boolean;

  label?: ReactNode;
}

/* Переключатель */
export const Switch = memo(
  forwardRef<HTMLInputElement, ISwitchProps>(
    (
      { className, disabled, value, style, id, onChange, isWide, labelPlacement = 'end', label, preIcon, postIcon },
      ref,
    ) => {
      const classes = classnames(
        styled.root,
        {
          [styled.root_Wide]: isWide,
        },
        className,
      );
      const containerClasses = classnames(styled.container, {
        [styled.container_Checked]: value,
      });
      const toggleClasses = classnames(styled.toggle, {
        [styled.toggle_Checked]: value,
      });

      const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.(e.target.checked);
      };

      return (
        <label className={classes} style={style} data-id={id} onClick={onUnitClickCallback(id)}>
          <input
            ref={ref}
            disabled={disabled}
            type="checkbox"
            className={styled.input}
            checked={value}
            onChange={handleChange}
          />
          {labelPlacement === 'start' && !!label && (
            <SwitchLabelValue label={label} preIcon={preIcon} postIcon={postIcon} />
          )}
          <div className={containerClasses}>
            <div className={toggleClasses} />
          </div>
          {labelPlacement === 'end' && !!label && (
            <SwitchLabelValue label={label} preIcon={preIcon} postIcon={postIcon} />
          )}
        </label>
      );
    },
  ),
);

Switch.displayName = 'Switch';
